import { useEffect, useContext, useCallback } from "react"

import VicinityContext from "../context/vicinityContext"
import {
    fetchAddress,
    fetchCountry,
    fetchNeighborhood,
} from "../services/googleMapsConnector"
import {
    SESSIONSTORAGE_LOCATION,
    LOCALSTORAGE_PLACE,
    SESSIONSTORAGE_SPOTLIGHTS,
} from "../const/storage"
import {
    getEntitiesData,
    getEntitiesSpotlights,
} from "../services/chaperonConnector"
import { getPlaceDetails, searchPlaces } from "../services/placesConnector"
import { consoleLog } from "../utilities/helpers"
import { useAuth } from "../hooks/useAuth"

export default function Vicinitizer() {
    const isLoggedIn = useAuth()
    let location = useContext(VicinityContext).location
    let setCountryCode = useContext(VicinityContext).setCountryCode
    let setSpotlightPlaces = useContext(VicinityContext).setSpotlightPlaces
    let setPlace = useContext(VicinityContext).setPlace

    let placeCountryCode = JSON.parse(
        localStorage.getItem(LOCALSTORAGE_PLACE)
    )?.country_code

    const loadEntitySpotlights = useCallback(async () => {
        const storedSpotlights = sessionStorage.getItem(
            SESSIONSTORAGE_SPOTLIGHTS
        )
        if (storedSpotlights) {
            setSpotlightPlaces(JSON.parse(storedSpotlights))
            consoleLog("Loaded entity spotlights from session storage.")
            return
        }

        let entitySpotlights
        try {
            entitySpotlights = await getEntitiesSpotlights(3)
        } catch (error) {
            consoleLog("Couldn't load entity spotlights:", error.message)
            return
        }
        for (let i = 0; i < entitySpotlights.length; i++) {
            let spotlight = entitySpotlights[i]
            let suggestions = await searchPlaces(spotlight.name)
            let placeDetails = await getPlaceDetails(suggestions[0].place_id)
            spotlight.fromGoogle = placeDetails
        }
        setSpotlightPlaces(entitySpotlights)
        sessionStorage.setItem(
            SESSIONSTORAGE_SPOTLIGHTS,
            JSON.stringify(entitySpotlights)
        )
    }, [setSpotlightPlaces])

    // Spotlights are shown only on logged-in screens and the endpoint needs a
    // login, so logged-out visitors don't request them (it was an uncaught 403).
    useEffect(() => {
        if (isLoggedIn) loadEntitySpotlights()
    }, [isLoggedIn, loadEntitySpotlights])

    useEffect(() => {
        if (
            // If location country code is not set (TODO: or location is less than 5 seconds old), and has coordinates
            //TODO: Explore reducing condition to only check if location data is less than 5 seconds old
            !placeCountryCode &&
            location.coordinates.latitude &&
            location.coordinates.longitude
        ) {
            consoleLog("Setting Place based on location data.")

            //TODO: Refactor to store either location or neighborhood in sessionStorage
            sessionStorage.setItem(
                SESSIONSTORAGE_LOCATION,
                JSON.stringify(location)
            )
            fetchAddress(location).then(async (addressComponents) => {
                let neighborhoodArray = await fetchNeighborhood(
                    addressComponents
                )
                let neighborhood = neighborhoodArray.join(", ")

                let country = await fetchCountry(addressComponents)
                let neighborhoods = await searchPlaces(neighborhood)
                let placeDetails = await getPlaceDetails(
                    neighborhoods[0].place_id
                )
                let neighborhoodPlaces = await getEntitiesData(
                    placeDetails.name,
                    country,
                    placeDetails.formatted_address
                )
                let neighborhoodPlace = neighborhoodPlaces[0]
                // TODO: Check for accuracy of match (e.g. proximity, country, population, etc.)
                neighborhoodPlace.fromGoogle = placeDetails
                setPlace(neighborhoodPlace)
            })
        } else {
            consoleLog("Vicinitizer - Place already set.")
        }
    }, [location, setCountryCode, placeCountryCode, setPlace])

    return null
}
